/**
 * Generated by orval v8.15.0 🍺
 * Do not edit manually.
 * Сервис Интранет — API
 * API внутреннего корпоративного портала
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  unref
} from 'vue';
import type {
  MaybeRef
} from 'vue';

import type {
  AcceptMilestoneDto,
  AddMemberDto,
  CreateAreaDto,
  CreateEventDto,
  CreateFolderDto,
  CreateProjectDto,
  ProjectAreaDto,
  ProjectDetailDto,
  ProjectEventDto,
  ProjectFolderDto,
  ProjectListItemDto,
  ProjectMaterialDownloadUrlDto,
  ProjectMaterialDto,
  ProjectMemberDto,
  ProjectsControllerCreateMaterialV1Body,
  ProjectsControllerListEventsV1Params,
  ProjectsControllerListMaterialsV1Params,
  ProjectsControllerListV1Params,
  SetAttendeesDto,
  UpdateAreaDto,
  UpdateEventDto,
  UpdateFolderDto,
  UpdateProjectDto
} from '../models';

import { apiRequest } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export interface projectsControllerListV1Response200 {
  data: ProjectListItemDto[]
  status: 200
}

export type projectsControllerListV1ResponseSuccess = (projectsControllerListV1Response200) & {
  headers: Headers;
};
;

export type projectsControllerListV1Response = (projectsControllerListV1ResponseSuccess)

export const getProjectsControllerListV1Url = (params?: ProjectsControllerListV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/projects?${stringifiedParams}` : `/api/v1/projects`
}

/**
 * @summary Список проектов
 */
export const projectsControllerListV1 = async (params?: ProjectsControllerListV1Params, options?: RequestInit): Promise<projectsControllerListV1Response> => {

  return apiRequest<projectsControllerListV1Response>(getProjectsControllerListV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getProjectsControllerListV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsControllerListV1>>, TError,{params?: ProjectsControllerListV1Params}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof projectsControllerListV1>>, TError,{params?: ProjectsControllerListV1Params}, TContext> => {

const mutationKey = ['projectsControllerListV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectsControllerListV1>>, {params?: ProjectsControllerListV1Params}> = (props) => {
          const {params} = props ?? {};

          return  projectsControllerListV1(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProjectsControllerListV1MutationResult = NonNullable<Awaited<ReturnType<typeof projectsControllerListV1>>>

    export type ProjectsControllerListV1MutationError = unknown

    /**
 * @summary Список проектов
 */
export const useProjectsControllerListV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsControllerListV1>>, TError,{params?: ProjectsControllerListV1Params}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof projectsControllerListV1>>,
        TError,
        {params?: ProjectsControllerListV1Params},
        TContext
      > => {
      return useMutation(getProjectsControllerListV1MutationOptions(options), queryClient);
    }
    export interface projectsControllerCreateV1Response200 {
  data: ProjectDetailDto
  status: 200
}

export type projectsControllerCreateV1ResponseSuccess = (projectsControllerCreateV1Response200) & {
  headers: Headers;
};
;

export type projectsControllerCreateV1Response = (projectsControllerCreateV1ResponseSuccess)

export const getProjectsControllerCreateV1Url = () => {




  return `/api/v1/projects`
}

/**
 * @summary Создать проект (ADMIN или модератор projects)
 */
export const projectsControllerCreateV1 = async (createProjectDto: CreateProjectDto, options?: RequestInit): Promise<projectsControllerCreateV1Response> => {

  return apiRequest<projectsControllerCreateV1Response>(getProjectsControllerCreateV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createProjectDto)
  }
);}





export const getProjectsControllerCreateV1QueryKey = (createProjectDto?: MaybeRef<CreateProjectDto>,) => {
    return [
    'POST', 'api','v1','projects', createProjectDto
    ] as const;
    }


export const getProjectsControllerCreateV1QueryOptions = <TData = Awaited<ReturnType<typeof projectsControllerCreateV1>>, TError = unknown>(createProjectDto: MaybeRef<CreateProjectDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerCreateV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getProjectsControllerCreateV1QueryKey(createProjectDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsControllerCreateV1>>> = ({ signal }) => projectsControllerCreateV1(unref(createProjectDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectsControllerCreateV1>>, TError, TData>
}

export type ProjectsControllerCreateV1QueryResult = NonNullable<Awaited<ReturnType<typeof projectsControllerCreateV1>>>
export type ProjectsControllerCreateV1QueryError = unknown


/**
 * @summary Создать проект (ADMIN или модератор projects)
 */

export function useProjectsControllerCreateV1<TData = Awaited<ReturnType<typeof projectsControllerCreateV1>>, TError = unknown>(
 createProjectDto: MaybeRef<CreateProjectDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerCreateV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsControllerCreateV1QueryOptions(createProjectDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export interface projectsControllerGetByIdV1Response200 {
  data: ProjectDetailDto
  status: 200
}

export type projectsControllerGetByIdV1ResponseSuccess = (projectsControllerGetByIdV1Response200) & {
  headers: Headers;
};
;

export type projectsControllerGetByIdV1Response = (projectsControllerGetByIdV1ResponseSuccess)

export const getProjectsControllerGetByIdV1Url = (id: string,) => {




  return `/api/v1/projects/${id}`
}

/**
 * @summary Проект с направлениями
 */
export const projectsControllerGetByIdV1 = async (id: string, options?: RequestInit): Promise<projectsControllerGetByIdV1Response> => {

  return apiRequest<projectsControllerGetByIdV1Response>(getProjectsControllerGetByIdV1Url(id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getProjectsControllerGetByIdV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsControllerGetByIdV1>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof projectsControllerGetByIdV1>>, TError,{id: string}, TContext> => {

const mutationKey = ['projectsControllerGetByIdV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectsControllerGetByIdV1>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  projectsControllerGetByIdV1(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProjectsControllerGetByIdV1MutationResult = NonNullable<Awaited<ReturnType<typeof projectsControllerGetByIdV1>>>

    export type ProjectsControllerGetByIdV1MutationError = unknown

    /**
 * @summary Проект с направлениями
 */
export const useProjectsControllerGetByIdV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsControllerGetByIdV1>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof projectsControllerGetByIdV1>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getProjectsControllerGetByIdV1MutationOptions(options), queryClient);
    }
    export interface projectsControllerUpdateV1Response200 {
  data: ProjectDetailDto
  status: 200
}

export type projectsControllerUpdateV1ResponseSuccess = (projectsControllerUpdateV1Response200) & {
  headers: Headers;
};
;

export type projectsControllerUpdateV1Response = (projectsControllerUpdateV1ResponseSuccess)

export const getProjectsControllerUpdateV1Url = (id: string,) => {




  return `/api/v1/projects/${id}`
}

/**
 * @summary Изменить проект (руководитель/модератор/ADMIN)
 */
export const projectsControllerUpdateV1 = async (id: string,
    updateProjectDto: UpdateProjectDto, options?: RequestInit): Promise<projectsControllerUpdateV1Response> => {

  return apiRequest<projectsControllerUpdateV1Response>(getProjectsControllerUpdateV1Url(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateProjectDto)
  }
);}





export const getProjectsControllerUpdateV1QueryKey = (id: MaybeRef<string>,
    updateProjectDto?: MaybeRef<UpdateProjectDto>,) => {
    return [
    'PATCH', 'api','v1','projects',id, updateProjectDto
    ] as const;
    }


export const getProjectsControllerUpdateV1QueryOptions = <TData = Awaited<ReturnType<typeof projectsControllerUpdateV1>>, TError = unknown>(id: MaybeRef<string>,
    updateProjectDto: MaybeRef<UpdateProjectDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerUpdateV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getProjectsControllerUpdateV1QueryKey(id,updateProjectDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsControllerUpdateV1>>> = ({ signal }) => projectsControllerUpdateV1(unref(id),unref(updateProjectDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectsControllerUpdateV1>>, TError, TData>
}

export type ProjectsControllerUpdateV1QueryResult = NonNullable<Awaited<ReturnType<typeof projectsControllerUpdateV1>>>
export type ProjectsControllerUpdateV1QueryError = unknown


/**
 * @summary Изменить проект (руководитель/модератор/ADMIN)
 */

export function useProjectsControllerUpdateV1<TData = Awaited<ReturnType<typeof projectsControllerUpdateV1>>, TError = unknown>(
 id: MaybeRef<string>,
    updateProjectDto: MaybeRef<UpdateProjectDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerUpdateV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsControllerUpdateV1QueryOptions(id,updateProjectDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export interface projectsControllerRemoveV1Response204 {
  data: void
  status: 204
}

export type projectsControllerRemoveV1ResponseSuccess = (projectsControllerRemoveV1Response204) & {
  headers: Headers;
};
;

export type projectsControllerRemoveV1Response = (projectsControllerRemoveV1ResponseSuccess)

export const getProjectsControllerRemoveV1Url = (id: string,) => {




  return `/api/v1/projects/${id}`
}

/**
 * @summary Удалить проект (ADMIN или модератор projects)
 */
export const projectsControllerRemoveV1 = async (id: string, options?: RequestInit): Promise<projectsControllerRemoveV1Response> => {

  return apiRequest<projectsControllerRemoveV1Response>(getProjectsControllerRemoveV1Url(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getProjectsControllerRemoveV1QueryKey = (id: MaybeRef<string>,) => {
    return [
    'DELETE', 'api','v1','projects',id
    ] as const;
    }


export const getProjectsControllerRemoveV1QueryOptions = <TData = Awaited<ReturnType<typeof projectsControllerRemoveV1>>, TError = unknown>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerRemoveV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getProjectsControllerRemoveV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsControllerRemoveV1>>> = ({ signal }) => projectsControllerRemoveV1(unref(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectsControllerRemoveV1>>, TError, TData>
}

export type ProjectsControllerRemoveV1QueryResult = NonNullable<Awaited<ReturnType<typeof projectsControllerRemoveV1>>>
export type ProjectsControllerRemoveV1QueryError = unknown


/**
 * @summary Удалить проект (ADMIN или модератор projects)
 */

export function useProjectsControllerRemoveV1<TData = Awaited<ReturnType<typeof projectsControllerRemoveV1>>, TError = unknown>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerRemoveV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsControllerRemoveV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export interface projectsControllerCreateAreaV1Response200 {
  data: ProjectAreaDto
  status: 200
}

export type projectsControllerCreateAreaV1ResponseSuccess = (projectsControllerCreateAreaV1Response200) & {
  headers: Headers;
};
;

export type projectsControllerCreateAreaV1Response = (projectsControllerCreateAreaV1ResponseSuccess)

export const getProjectsControllerCreateAreaV1Url = (id: string,) => {




  return `/api/v1/projects/${id}/areas`
}

/**
 * @summary Добавить направление (руководитель проекта/модератор/ADMIN)
 */
export const projectsControllerCreateAreaV1 = async (id: string,
    createAreaDto: CreateAreaDto, options?: RequestInit): Promise<projectsControllerCreateAreaV1Response> => {

  return apiRequest<projectsControllerCreateAreaV1Response>(getProjectsControllerCreateAreaV1Url(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createAreaDto)
  }
);}





export const getProjectsControllerCreateAreaV1QueryKey = (id: MaybeRef<string>,
    createAreaDto?: MaybeRef<CreateAreaDto>,) => {
    return [
    'POST', 'api','v1','projects',id,'areas', createAreaDto
    ] as const;
    }


export const getProjectsControllerCreateAreaV1QueryOptions = <TData = Awaited<ReturnType<typeof projectsControllerCreateAreaV1>>, TError = unknown>(id: MaybeRef<string>,
    createAreaDto: MaybeRef<CreateAreaDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerCreateAreaV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getProjectsControllerCreateAreaV1QueryKey(id,createAreaDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsControllerCreateAreaV1>>> = ({ signal }) => projectsControllerCreateAreaV1(unref(id),unref(createAreaDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectsControllerCreateAreaV1>>, TError, TData>
}

export type ProjectsControllerCreateAreaV1QueryResult = NonNullable<Awaited<ReturnType<typeof projectsControllerCreateAreaV1>>>
export type ProjectsControllerCreateAreaV1QueryError = unknown


/**
 * @summary Добавить направление (руководитель проекта/модератор/ADMIN)
 */

export function useProjectsControllerCreateAreaV1<TData = Awaited<ReturnType<typeof projectsControllerCreateAreaV1>>, TError = unknown>(
 id: MaybeRef<string>,
    createAreaDto: MaybeRef<CreateAreaDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerCreateAreaV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsControllerCreateAreaV1QueryOptions(id,createAreaDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export interface projectsControllerUpdateAreaV1Response200 {
  data: ProjectAreaDto
  status: 200
}

export type projectsControllerUpdateAreaV1ResponseSuccess = (projectsControllerUpdateAreaV1Response200) & {
  headers: Headers;
};
;

export type projectsControllerUpdateAreaV1Response = (projectsControllerUpdateAreaV1ResponseSuccess)

export const getProjectsControllerUpdateAreaV1Url = (id: string,
    areaId: string,) => {




  return `/api/v1/projects/${id}/areas/${areaId}`
}

/**
 * @summary Изменить направление (ответственный/руководитель/модератор/ADMIN)
 */
export const projectsControllerUpdateAreaV1 = async (id: string,
    areaId: string,
    updateAreaDto: UpdateAreaDto, options?: RequestInit): Promise<projectsControllerUpdateAreaV1Response> => {

  return apiRequest<projectsControllerUpdateAreaV1Response>(getProjectsControllerUpdateAreaV1Url(id,areaId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateAreaDto)
  }
);}





export const getProjectsControllerUpdateAreaV1QueryKey = (id: MaybeRef<string>,
    areaId: MaybeRef<string>,
    updateAreaDto?: MaybeRef<UpdateAreaDto>,) => {
    return [
    'PATCH', 'api','v1','projects',id,'areas',areaId, updateAreaDto
    ] as const;
    }


export const getProjectsControllerUpdateAreaV1QueryOptions = <TData = Awaited<ReturnType<typeof projectsControllerUpdateAreaV1>>, TError = unknown>(id: MaybeRef<string>,
    areaId: MaybeRef<string>,
    updateAreaDto: MaybeRef<UpdateAreaDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerUpdateAreaV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getProjectsControllerUpdateAreaV1QueryKey(id,areaId,updateAreaDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsControllerUpdateAreaV1>>> = ({ signal }) => projectsControllerUpdateAreaV1(unref(id),unref(areaId),unref(updateAreaDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined && unref(areaId) !== null && unref(areaId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectsControllerUpdateAreaV1>>, TError, TData>
}

export type ProjectsControllerUpdateAreaV1QueryResult = NonNullable<Awaited<ReturnType<typeof projectsControllerUpdateAreaV1>>>
export type ProjectsControllerUpdateAreaV1QueryError = unknown


/**
 * @summary Изменить направление (ответственный/руководитель/модератор/ADMIN)
 */

export function useProjectsControllerUpdateAreaV1<TData = Awaited<ReturnType<typeof projectsControllerUpdateAreaV1>>, TError = unknown>(
 id: MaybeRef<string>,
    areaId: MaybeRef<string>,
    updateAreaDto: MaybeRef<UpdateAreaDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerUpdateAreaV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsControllerUpdateAreaV1QueryOptions(id,areaId,updateAreaDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export interface projectsControllerRemoveAreaV1Response204 {
  data: void
  status: 204
}

export type projectsControllerRemoveAreaV1ResponseSuccess = (projectsControllerRemoveAreaV1Response204) & {
  headers: Headers;
};
;

export type projectsControllerRemoveAreaV1Response = (projectsControllerRemoveAreaV1ResponseSuccess)

export const getProjectsControllerRemoveAreaV1Url = (id: string,
    areaId: string,) => {




  return `/api/v1/projects/${id}/areas/${areaId}`
}

/**
 * @summary Удалить направление (руководитель проекта/модератор/ADMIN)
 */
export const projectsControllerRemoveAreaV1 = async (id: string,
    areaId: string, options?: RequestInit): Promise<projectsControllerRemoveAreaV1Response> => {

  return apiRequest<projectsControllerRemoveAreaV1Response>(getProjectsControllerRemoveAreaV1Url(id,areaId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getProjectsControllerRemoveAreaV1QueryKey = (id: MaybeRef<string>,
    areaId: MaybeRef<string>,) => {
    return [
    'DELETE', 'api','v1','projects',id,'areas',areaId
    ] as const;
    }


export const getProjectsControllerRemoveAreaV1QueryOptions = <TData = Awaited<ReturnType<typeof projectsControllerRemoveAreaV1>>, TError = unknown>(id: MaybeRef<string>,
    areaId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerRemoveAreaV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getProjectsControllerRemoveAreaV1QueryKey(id,areaId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsControllerRemoveAreaV1>>> = ({ signal }) => projectsControllerRemoveAreaV1(unref(id),unref(areaId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined && unref(areaId) !== null && unref(areaId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectsControllerRemoveAreaV1>>, TError, TData>
}

export type ProjectsControllerRemoveAreaV1QueryResult = NonNullable<Awaited<ReturnType<typeof projectsControllerRemoveAreaV1>>>
export type ProjectsControllerRemoveAreaV1QueryError = unknown


/**
 * @summary Удалить направление (руководитель проекта/модератор/ADMIN)
 */

export function useProjectsControllerRemoveAreaV1<TData = Awaited<ReturnType<typeof projectsControllerRemoveAreaV1>>, TError = unknown>(
 id: MaybeRef<string>,
    areaId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerRemoveAreaV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsControllerRemoveAreaV1QueryOptions(id,areaId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export interface projectsControllerListFoldersV1Response200 {
  data: ProjectFolderDto[]
  status: 200
}

export type projectsControllerListFoldersV1ResponseSuccess = (projectsControllerListFoldersV1Response200) & {
  headers: Headers;
};
;

export type projectsControllerListFoldersV1Response = (projectsControllerListFoldersV1ResponseSuccess)

export const getProjectsControllerListFoldersV1Url = (id: string,
    areaId: string,) => {




  return `/api/v1/projects/${id}/areas/${areaId}/folders`
}

/**
 * @summary Папки файлов направления
 */
export const projectsControllerListFoldersV1 = async (id: string,
    areaId: string, options?: RequestInit): Promise<projectsControllerListFoldersV1Response> => {

  return apiRequest<projectsControllerListFoldersV1Response>(getProjectsControllerListFoldersV1Url(id,areaId),
  {
    ...options,
    method: 'GET'


  }
);}




export const getProjectsControllerListFoldersV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsControllerListFoldersV1>>, TError,{id: string;areaId: string}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof projectsControllerListFoldersV1>>, TError,{id: string;areaId: string}, TContext> => {

const mutationKey = ['projectsControllerListFoldersV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectsControllerListFoldersV1>>, {id: string;areaId: string}> = (props) => {
          const {id,areaId} = props ?? {};

          return  projectsControllerListFoldersV1(id,areaId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProjectsControllerListFoldersV1MutationResult = NonNullable<Awaited<ReturnType<typeof projectsControllerListFoldersV1>>>

    export type ProjectsControllerListFoldersV1MutationError = unknown

    /**
 * @summary Папки файлов направления
 */
export const useProjectsControllerListFoldersV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsControllerListFoldersV1>>, TError,{id: string;areaId: string}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof projectsControllerListFoldersV1>>,
        TError,
        {id: string;areaId: string},
        TContext
      > => {
      return useMutation(getProjectsControllerListFoldersV1MutationOptions(options), queryClient);
    }
    export interface projectsControllerCreateFolderV1Response200 {
  data: ProjectFolderDto
  status: 200
}

export type projectsControllerCreateFolderV1ResponseSuccess = (projectsControllerCreateFolderV1Response200) & {
  headers: Headers;
};
;

export type projectsControllerCreateFolderV1Response = (projectsControllerCreateFolderV1ResponseSuccess)

export const getProjectsControllerCreateFolderV1Url = (id: string,
    areaId: string,) => {




  return `/api/v1/projects/${id}/areas/${areaId}/folders`
}

/**
 * @summary Создать папку (ответственный направления/руководитель/модератор/ADMIN)
 */
export const projectsControllerCreateFolderV1 = async (id: string,
    areaId: string,
    createFolderDto: CreateFolderDto, options?: RequestInit): Promise<projectsControllerCreateFolderV1Response> => {

  return apiRequest<projectsControllerCreateFolderV1Response>(getProjectsControllerCreateFolderV1Url(id,areaId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createFolderDto)
  }
);}





export const getProjectsControllerCreateFolderV1QueryKey = (id: MaybeRef<string>,
    areaId: MaybeRef<string>,
    createFolderDto?: MaybeRef<CreateFolderDto>,) => {
    return [
    'POST', 'api','v1','projects',id,'areas',areaId,'folders', createFolderDto
    ] as const;
    }


export const getProjectsControllerCreateFolderV1QueryOptions = <TData = Awaited<ReturnType<typeof projectsControllerCreateFolderV1>>, TError = unknown>(id: MaybeRef<string>,
    areaId: MaybeRef<string>,
    createFolderDto: MaybeRef<CreateFolderDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerCreateFolderV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getProjectsControllerCreateFolderV1QueryKey(id,areaId,createFolderDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsControllerCreateFolderV1>>> = ({ signal }) => projectsControllerCreateFolderV1(unref(id),unref(areaId),unref(createFolderDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined && unref(areaId) !== null && unref(areaId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectsControllerCreateFolderV1>>, TError, TData>
}

export type ProjectsControllerCreateFolderV1QueryResult = NonNullable<Awaited<ReturnType<typeof projectsControllerCreateFolderV1>>>
export type ProjectsControllerCreateFolderV1QueryError = unknown


/**
 * @summary Создать папку (ответственный направления/руководитель/модератор/ADMIN)
 */

export function useProjectsControllerCreateFolderV1<TData = Awaited<ReturnType<typeof projectsControllerCreateFolderV1>>, TError = unknown>(
 id: MaybeRef<string>,
    areaId: MaybeRef<string>,
    createFolderDto: MaybeRef<CreateFolderDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerCreateFolderV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsControllerCreateFolderV1QueryOptions(id,areaId,createFolderDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export interface projectsControllerUpdateFolderV1Response200 {
  data: ProjectFolderDto
  status: 200
}

export type projectsControllerUpdateFolderV1ResponseSuccess = (projectsControllerUpdateFolderV1Response200) & {
  headers: Headers;
};
;

export type projectsControllerUpdateFolderV1Response = (projectsControllerUpdateFolderV1ResponseSuccess)

export const getProjectsControllerUpdateFolderV1Url = (id: string,
    areaId: string,
    folderId: string,) => {




  return `/api/v1/projects/${id}/areas/${areaId}/folders/${folderId}`
}

/**
 * @summary Переименовать/переместить папку
 */
export const projectsControllerUpdateFolderV1 = async (id: string,
    areaId: string,
    folderId: string,
    updateFolderDto: UpdateFolderDto, options?: RequestInit): Promise<projectsControllerUpdateFolderV1Response> => {

  return apiRequest<projectsControllerUpdateFolderV1Response>(getProjectsControllerUpdateFolderV1Url(id,areaId,folderId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateFolderDto)
  }
);}





export const getProjectsControllerUpdateFolderV1QueryKey = (id: MaybeRef<string>,
    areaId: MaybeRef<string>,
    folderId: MaybeRef<string>,
    updateFolderDto?: MaybeRef<UpdateFolderDto>,) => {
    return [
    'PATCH', 'api','v1','projects',id,'areas',areaId,'folders',folderId, updateFolderDto
    ] as const;
    }


export const getProjectsControllerUpdateFolderV1QueryOptions = <TData = Awaited<ReturnType<typeof projectsControllerUpdateFolderV1>>, TError = unknown>(id: MaybeRef<string>,
    areaId: MaybeRef<string>,
    folderId: MaybeRef<string>,
    updateFolderDto: MaybeRef<UpdateFolderDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerUpdateFolderV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getProjectsControllerUpdateFolderV1QueryKey(id,areaId,folderId,updateFolderDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsControllerUpdateFolderV1>>> = ({ signal }) => projectsControllerUpdateFolderV1(unref(id),unref(areaId),unref(folderId),unref(updateFolderDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined && unref(areaId) !== null && unref(areaId) !== undefined && unref(folderId) !== null && unref(folderId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectsControllerUpdateFolderV1>>, TError, TData>
}

export type ProjectsControllerUpdateFolderV1QueryResult = NonNullable<Awaited<ReturnType<typeof projectsControllerUpdateFolderV1>>>
export type ProjectsControllerUpdateFolderV1QueryError = unknown


/**
 * @summary Переименовать/переместить папку
 */

export function useProjectsControllerUpdateFolderV1<TData = Awaited<ReturnType<typeof projectsControllerUpdateFolderV1>>, TError = unknown>(
 id: MaybeRef<string>,
    areaId: MaybeRef<string>,
    folderId: MaybeRef<string>,
    updateFolderDto: MaybeRef<UpdateFolderDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerUpdateFolderV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsControllerUpdateFolderV1QueryOptions(id,areaId,folderId,updateFolderDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export interface projectsControllerRemoveFolderV1Response204 {
  data: void
  status: 204
}

export type projectsControllerRemoveFolderV1ResponseSuccess = (projectsControllerRemoveFolderV1Response204) & {
  headers: Headers;
};
;

export type projectsControllerRemoveFolderV1Response = (projectsControllerRemoveFolderV1ResponseSuccess)

export const getProjectsControllerRemoveFolderV1Url = (id: string,
    areaId: string,
    folderId: string,) => {




  return `/api/v1/projects/${id}/areas/${areaId}/folders/${folderId}`
}

/**
 * @summary Удалить папку (файлы остаются в корне направления)
 */
export const projectsControllerRemoveFolderV1 = async (id: string,
    areaId: string,
    folderId: string, options?: RequestInit): Promise<projectsControllerRemoveFolderV1Response> => {

  return apiRequest<projectsControllerRemoveFolderV1Response>(getProjectsControllerRemoveFolderV1Url(id,areaId,folderId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getProjectsControllerRemoveFolderV1QueryKey = (id: MaybeRef<string>,
    areaId: MaybeRef<string>,
    folderId: MaybeRef<string>,) => {
    return [
    'DELETE', 'api','v1','projects',id,'areas',areaId,'folders',folderId
    ] as const;
    }


export const getProjectsControllerRemoveFolderV1QueryOptions = <TData = Awaited<ReturnType<typeof projectsControllerRemoveFolderV1>>, TError = unknown>(id: MaybeRef<string>,
    areaId: MaybeRef<string>,
    folderId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerRemoveFolderV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getProjectsControllerRemoveFolderV1QueryKey(id,areaId,folderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsControllerRemoveFolderV1>>> = ({ signal }) => projectsControllerRemoveFolderV1(unref(id),unref(areaId),unref(folderId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined && unref(areaId) !== null && unref(areaId) !== undefined && unref(folderId) !== null && unref(folderId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectsControllerRemoveFolderV1>>, TError, TData>
}

export type ProjectsControllerRemoveFolderV1QueryResult = NonNullable<Awaited<ReturnType<typeof projectsControllerRemoveFolderV1>>>
export type ProjectsControllerRemoveFolderV1QueryError = unknown


/**
 * @summary Удалить папку (файлы остаются в корне направления)
 */

export function useProjectsControllerRemoveFolderV1<TData = Awaited<ReturnType<typeof projectsControllerRemoveFolderV1>>, TError = unknown>(
 id: MaybeRef<string>,
    areaId: MaybeRef<string>,
    folderId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerRemoveFolderV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsControllerRemoveFolderV1QueryOptions(id,areaId,folderId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export interface projectsControllerListMembersV1Response200 {
  data: ProjectMemberDto[]
  status: 200
}

export type projectsControllerListMembersV1ResponseSuccess = (projectsControllerListMembersV1Response200) & {
  headers: Headers;
};
;

export type projectsControllerListMembersV1Response = (projectsControllerListMembersV1ResponseSuccess)

export const getProjectsControllerListMembersV1Url = (id: string,) => {




  return `/api/v1/projects/${id}/members`
}

/**
 * @summary Состав команды проекта
 */
export const projectsControllerListMembersV1 = async (id: string, options?: RequestInit): Promise<projectsControllerListMembersV1Response> => {

  return apiRequest<projectsControllerListMembersV1Response>(getProjectsControllerListMembersV1Url(id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getProjectsControllerListMembersV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsControllerListMembersV1>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof projectsControllerListMembersV1>>, TError,{id: string}, TContext> => {

const mutationKey = ['projectsControllerListMembersV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectsControllerListMembersV1>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  projectsControllerListMembersV1(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProjectsControllerListMembersV1MutationResult = NonNullable<Awaited<ReturnType<typeof projectsControllerListMembersV1>>>

    export type ProjectsControllerListMembersV1MutationError = unknown

    /**
 * @summary Состав команды проекта
 */
export const useProjectsControllerListMembersV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsControllerListMembersV1>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof projectsControllerListMembersV1>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getProjectsControllerListMembersV1MutationOptions(options), queryClient);
    }
    export interface projectsControllerAddMemberV1Response200 {
  data: ProjectMemberDto
  status: 200
}

export type projectsControllerAddMemberV1ResponseSuccess = (projectsControllerAddMemberV1Response200) & {
  headers: Headers;
};
;

export type projectsControllerAddMemberV1Response = (projectsControllerAddMemberV1ResponseSuccess)

export const getProjectsControllerAddMemberV1Url = (id: string,) => {




  return `/api/v1/projects/${id}/members`
}

/**
 * @summary Добавить участника (руководитель/ответственный/модератор/ADMIN)
 */
export const projectsControllerAddMemberV1 = async (id: string,
    addMemberDto: AddMemberDto, options?: RequestInit): Promise<projectsControllerAddMemberV1Response> => {

  return apiRequest<projectsControllerAddMemberV1Response>(getProjectsControllerAddMemberV1Url(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addMemberDto)
  }
);}





export const getProjectsControllerAddMemberV1QueryKey = (id: MaybeRef<string>,
    addMemberDto?: MaybeRef<AddMemberDto>,) => {
    return [
    'POST', 'api','v1','projects',id,'members', addMemberDto
    ] as const;
    }


export const getProjectsControllerAddMemberV1QueryOptions = <TData = Awaited<ReturnType<typeof projectsControllerAddMemberV1>>, TError = unknown>(id: MaybeRef<string>,
    addMemberDto: MaybeRef<AddMemberDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerAddMemberV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getProjectsControllerAddMemberV1QueryKey(id,addMemberDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsControllerAddMemberV1>>> = ({ signal }) => projectsControllerAddMemberV1(unref(id),unref(addMemberDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectsControllerAddMemberV1>>, TError, TData>
}

export type ProjectsControllerAddMemberV1QueryResult = NonNullable<Awaited<ReturnType<typeof projectsControllerAddMemberV1>>>
export type ProjectsControllerAddMemberV1QueryError = unknown


/**
 * @summary Добавить участника (руководитель/ответственный/модератор/ADMIN)
 */

export function useProjectsControllerAddMemberV1<TData = Awaited<ReturnType<typeof projectsControllerAddMemberV1>>, TError = unknown>(
 id: MaybeRef<string>,
    addMemberDto: MaybeRef<AddMemberDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerAddMemberV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsControllerAddMemberV1QueryOptions(id,addMemberDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export interface projectsControllerRemoveMemberV1Response204 {
  data: void
  status: 204
}

export type projectsControllerRemoveMemberV1ResponseSuccess = (projectsControllerRemoveMemberV1Response204) & {
  headers: Headers;
};
;

export type projectsControllerRemoveMemberV1Response = (projectsControllerRemoveMemberV1ResponseSuccess)

export const getProjectsControllerRemoveMemberV1Url = (id: string,
    memberId: string,) => {




  return `/api/v1/projects/${id}/members/${memberId}`
}

/**
 * @summary Убрать участника
 */
export const projectsControllerRemoveMemberV1 = async (id: string,
    memberId: string, options?: RequestInit): Promise<projectsControllerRemoveMemberV1Response> => {

  return apiRequest<projectsControllerRemoveMemberV1Response>(getProjectsControllerRemoveMemberV1Url(id,memberId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getProjectsControllerRemoveMemberV1QueryKey = (id: MaybeRef<string>,
    memberId: MaybeRef<string>,) => {
    return [
    'DELETE', 'api','v1','projects',id,'members',memberId
    ] as const;
    }


export const getProjectsControllerRemoveMemberV1QueryOptions = <TData = Awaited<ReturnType<typeof projectsControllerRemoveMemberV1>>, TError = unknown>(id: MaybeRef<string>,
    memberId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerRemoveMemberV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getProjectsControllerRemoveMemberV1QueryKey(id,memberId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsControllerRemoveMemberV1>>> = ({ signal }) => projectsControllerRemoveMemberV1(unref(id),unref(memberId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined && unref(memberId) !== null && unref(memberId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectsControllerRemoveMemberV1>>, TError, TData>
}

export type ProjectsControllerRemoveMemberV1QueryResult = NonNullable<Awaited<ReturnType<typeof projectsControllerRemoveMemberV1>>>
export type ProjectsControllerRemoveMemberV1QueryError = unknown


/**
 * @summary Убрать участника
 */

export function useProjectsControllerRemoveMemberV1<TData = Awaited<ReturnType<typeof projectsControllerRemoveMemberV1>>, TError = unknown>(
 id: MaybeRef<string>,
    memberId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerRemoveMemberV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsControllerRemoveMemberV1QueryOptions(id,memberId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export interface projectsControllerListEventsV1Response200 {
  data: ProjectEventDto[]
  status: 200
}

export type projectsControllerListEventsV1ResponseSuccess = (projectsControllerListEventsV1Response200) & {
  headers: Headers;
};
;

export type projectsControllerListEventsV1Response = (projectsControllerListEventsV1ResponseSuccess)

export const getProjectsControllerListEventsV1Url = (id: string,
    params?: ProjectsControllerListEventsV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/projects/${id}/events?${stringifiedParams}` : `/api/v1/projects/${id}/events`
}

/**
 * @summary События проекта (контрольные точки/встречи/регулярные/разовые)
 */
export const projectsControllerListEventsV1 = async (id: string,
    params?: ProjectsControllerListEventsV1Params, options?: RequestInit): Promise<projectsControllerListEventsV1Response> => {

  return apiRequest<projectsControllerListEventsV1Response>(getProjectsControllerListEventsV1Url(id,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getProjectsControllerListEventsV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsControllerListEventsV1>>, TError,{id: string;params?: ProjectsControllerListEventsV1Params}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof projectsControllerListEventsV1>>, TError,{id: string;params?: ProjectsControllerListEventsV1Params}, TContext> => {

const mutationKey = ['projectsControllerListEventsV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectsControllerListEventsV1>>, {id: string;params?: ProjectsControllerListEventsV1Params}> = (props) => {
          const {id,params} = props ?? {};

          return  projectsControllerListEventsV1(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProjectsControllerListEventsV1MutationResult = NonNullable<Awaited<ReturnType<typeof projectsControllerListEventsV1>>>

    export type ProjectsControllerListEventsV1MutationError = unknown

    /**
 * @summary События проекта (контрольные точки/встречи/регулярные/разовые)
 */
export const useProjectsControllerListEventsV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsControllerListEventsV1>>, TError,{id: string;params?: ProjectsControllerListEventsV1Params}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof projectsControllerListEventsV1>>,
        TError,
        {id: string;params?: ProjectsControllerListEventsV1Params},
        TContext
      > => {
      return useMutation(getProjectsControllerListEventsV1MutationOptions(options), queryClient);
    }
    export interface projectsControllerCreateEventV1Response200 {
  data: ProjectEventDto
  status: 200
}

export type projectsControllerCreateEventV1ResponseSuccess = (projectsControllerCreateEventV1Response200) & {
  headers: Headers;
};
;

export type projectsControllerCreateEventV1Response = (projectsControllerCreateEventV1ResponseSuccess)

export const getProjectsControllerCreateEventV1Url = (id: string,) => {




  return `/api/v1/projects/${id}/events`
}

/**
 * @summary Добавить событие
 */
export const projectsControllerCreateEventV1 = async (id: string,
    createEventDto: CreateEventDto, options?: RequestInit): Promise<projectsControllerCreateEventV1Response> => {

  return apiRequest<projectsControllerCreateEventV1Response>(getProjectsControllerCreateEventV1Url(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createEventDto)
  }
);}





export const getProjectsControllerCreateEventV1QueryKey = (id: MaybeRef<string>,
    createEventDto?: MaybeRef<CreateEventDto>,) => {
    return [
    'POST', 'api','v1','projects',id,'events', createEventDto
    ] as const;
    }


export const getProjectsControllerCreateEventV1QueryOptions = <TData = Awaited<ReturnType<typeof projectsControllerCreateEventV1>>, TError = unknown>(id: MaybeRef<string>,
    createEventDto: MaybeRef<CreateEventDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerCreateEventV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getProjectsControllerCreateEventV1QueryKey(id,createEventDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsControllerCreateEventV1>>> = ({ signal }) => projectsControllerCreateEventV1(unref(id),unref(createEventDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectsControllerCreateEventV1>>, TError, TData>
}

export type ProjectsControllerCreateEventV1QueryResult = NonNullable<Awaited<ReturnType<typeof projectsControllerCreateEventV1>>>
export type ProjectsControllerCreateEventV1QueryError = unknown


/**
 * @summary Добавить событие
 */

export function useProjectsControllerCreateEventV1<TData = Awaited<ReturnType<typeof projectsControllerCreateEventV1>>, TError = unknown>(
 id: MaybeRef<string>,
    createEventDto: MaybeRef<CreateEventDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerCreateEventV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsControllerCreateEventV1QueryOptions(id,createEventDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export interface projectsControllerUpdateEventV1Response200 {
  data: ProjectEventDto
  status: 200
}

export type projectsControllerUpdateEventV1ResponseSuccess = (projectsControllerUpdateEventV1Response200) & {
  headers: Headers;
};
;

export type projectsControllerUpdateEventV1Response = (projectsControllerUpdateEventV1ResponseSuccess)

export const getProjectsControllerUpdateEventV1Url = (id: string,
    eventId: string,) => {




  return `/api/v1/projects/${id}/events/${eventId}`
}

/**
 * @summary Изменить событие
 */
export const projectsControllerUpdateEventV1 = async (id: string,
    eventId: string,
    updateEventDto: UpdateEventDto, options?: RequestInit): Promise<projectsControllerUpdateEventV1Response> => {

  return apiRequest<projectsControllerUpdateEventV1Response>(getProjectsControllerUpdateEventV1Url(id,eventId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateEventDto)
  }
);}





export const getProjectsControllerUpdateEventV1QueryKey = (id: MaybeRef<string>,
    eventId: MaybeRef<string>,
    updateEventDto?: MaybeRef<UpdateEventDto>,) => {
    return [
    'PATCH', 'api','v1','projects',id,'events',eventId, updateEventDto
    ] as const;
    }


export const getProjectsControllerUpdateEventV1QueryOptions = <TData = Awaited<ReturnType<typeof projectsControllerUpdateEventV1>>, TError = unknown>(id: MaybeRef<string>,
    eventId: MaybeRef<string>,
    updateEventDto: MaybeRef<UpdateEventDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerUpdateEventV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getProjectsControllerUpdateEventV1QueryKey(id,eventId,updateEventDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsControllerUpdateEventV1>>> = ({ signal }) => projectsControllerUpdateEventV1(unref(id),unref(eventId),unref(updateEventDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined && unref(eventId) !== null && unref(eventId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectsControllerUpdateEventV1>>, TError, TData>
}

export type ProjectsControllerUpdateEventV1QueryResult = NonNullable<Awaited<ReturnType<typeof projectsControllerUpdateEventV1>>>
export type ProjectsControllerUpdateEventV1QueryError = unknown


/**
 * @summary Изменить событие
 */

export function useProjectsControllerUpdateEventV1<TData = Awaited<ReturnType<typeof projectsControllerUpdateEventV1>>, TError = unknown>(
 id: MaybeRef<string>,
    eventId: MaybeRef<string>,
    updateEventDto: MaybeRef<UpdateEventDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerUpdateEventV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsControllerUpdateEventV1QueryOptions(id,eventId,updateEventDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export interface projectsControllerRemoveEventV1Response204 {
  data: void
  status: 204
}

export type projectsControllerRemoveEventV1ResponseSuccess = (projectsControllerRemoveEventV1Response204) & {
  headers: Headers;
};
;

export type projectsControllerRemoveEventV1Response = (projectsControllerRemoveEventV1ResponseSuccess)

export const getProjectsControllerRemoveEventV1Url = (id: string,
    eventId: string,) => {




  return `/api/v1/projects/${id}/events/${eventId}`
}

/**
 * @summary Удалить событие
 */
export const projectsControllerRemoveEventV1 = async (id: string,
    eventId: string, options?: RequestInit): Promise<projectsControllerRemoveEventV1Response> => {

  return apiRequest<projectsControllerRemoveEventV1Response>(getProjectsControllerRemoveEventV1Url(id,eventId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getProjectsControllerRemoveEventV1QueryKey = (id: MaybeRef<string>,
    eventId: MaybeRef<string>,) => {
    return [
    'DELETE', 'api','v1','projects',id,'events',eventId
    ] as const;
    }


export const getProjectsControllerRemoveEventV1QueryOptions = <TData = Awaited<ReturnType<typeof projectsControllerRemoveEventV1>>, TError = unknown>(id: MaybeRef<string>,
    eventId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerRemoveEventV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getProjectsControllerRemoveEventV1QueryKey(id,eventId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsControllerRemoveEventV1>>> = ({ signal }) => projectsControllerRemoveEventV1(unref(id),unref(eventId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined && unref(eventId) !== null && unref(eventId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectsControllerRemoveEventV1>>, TError, TData>
}

export type ProjectsControllerRemoveEventV1QueryResult = NonNullable<Awaited<ReturnType<typeof projectsControllerRemoveEventV1>>>
export type ProjectsControllerRemoveEventV1QueryError = unknown


/**
 * @summary Удалить событие
 */

export function useProjectsControllerRemoveEventV1<TData = Awaited<ReturnType<typeof projectsControllerRemoveEventV1>>, TError = unknown>(
 id: MaybeRef<string>,
    eventId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerRemoveEventV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsControllerRemoveEventV1QueryOptions(id,eventId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export interface projectsControllerSetAttendeesV1Response200 {
  data: ProjectEventDto
  status: 200
}

export type projectsControllerSetAttendeesV1ResponseSuccess = (projectsControllerSetAttendeesV1Response200) & {
  headers: Headers;
};
;

export type projectsControllerSetAttendeesV1Response = (projectsControllerSetAttendeesV1ResponseSuccess)

export const getProjectsControllerSetAttendeesV1Url = (id: string,
    eventId: string,) => {




  return `/api/v1/projects/${id}/events/${eventId}/attendees`
}

/**
 * @summary Задать участников встречи
 */
export const projectsControllerSetAttendeesV1 = async (id: string,
    eventId: string,
    setAttendeesDto: SetAttendeesDto, options?: RequestInit): Promise<projectsControllerSetAttendeesV1Response> => {

  return apiRequest<projectsControllerSetAttendeesV1Response>(getProjectsControllerSetAttendeesV1Url(id,eventId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setAttendeesDto)
  }
);}





export const getProjectsControllerSetAttendeesV1QueryKey = (id: MaybeRef<string>,
    eventId: MaybeRef<string>,
    setAttendeesDto?: MaybeRef<SetAttendeesDto>,) => {
    return [
    'PUT', 'api','v1','projects',id,'events',eventId,'attendees', setAttendeesDto
    ] as const;
    }


export const getProjectsControllerSetAttendeesV1QueryOptions = <TData = Awaited<ReturnType<typeof projectsControllerSetAttendeesV1>>, TError = unknown>(id: MaybeRef<string>,
    eventId: MaybeRef<string>,
    setAttendeesDto: MaybeRef<SetAttendeesDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerSetAttendeesV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getProjectsControllerSetAttendeesV1QueryKey(id,eventId,setAttendeesDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsControllerSetAttendeesV1>>> = ({ signal }) => projectsControllerSetAttendeesV1(unref(id),unref(eventId),unref(setAttendeesDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined && unref(eventId) !== null && unref(eventId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectsControllerSetAttendeesV1>>, TError, TData>
}

export type ProjectsControllerSetAttendeesV1QueryResult = NonNullable<Awaited<ReturnType<typeof projectsControllerSetAttendeesV1>>>
export type ProjectsControllerSetAttendeesV1QueryError = unknown


/**
 * @summary Задать участников встречи
 */

export function useProjectsControllerSetAttendeesV1<TData = Awaited<ReturnType<typeof projectsControllerSetAttendeesV1>>, TError = unknown>(
 id: MaybeRef<string>,
    eventId: MaybeRef<string>,
    setAttendeesDto: MaybeRef<SetAttendeesDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerSetAttendeesV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsControllerSetAttendeesV1QueryOptions(id,eventId,setAttendeesDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export interface projectsControllerAcceptMilestoneV1Response200 {
  data: ProjectEventDto
  status: 200
}

export type projectsControllerAcceptMilestoneV1ResponseSuccess = (projectsControllerAcceptMilestoneV1Response200) & {
  headers: Headers;
};
;

export type projectsControllerAcceptMilestoneV1Response = (projectsControllerAcceptMilestoneV1ResponseSuccess)

export const getProjectsControllerAcceptMilestoneV1Url = (id: string,
    eventId: string,) => {




  return `/api/v1/projects/${id}/events/${eventId}/accept`
}

/**
 * @summary Принять / снять приёмку контрольной точки
 */
export const projectsControllerAcceptMilestoneV1 = async (id: string,
    eventId: string,
    acceptMilestoneDto: AcceptMilestoneDto, options?: RequestInit): Promise<projectsControllerAcceptMilestoneV1Response> => {

  return apiRequest<projectsControllerAcceptMilestoneV1Response>(getProjectsControllerAcceptMilestoneV1Url(id,eventId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(acceptMilestoneDto)
  }
);}





export const getProjectsControllerAcceptMilestoneV1QueryKey = (id: MaybeRef<string>,
    eventId: MaybeRef<string>,
    acceptMilestoneDto?: MaybeRef<AcceptMilestoneDto>,) => {
    return [
    'PATCH', 'api','v1','projects',id,'events',eventId,'accept', acceptMilestoneDto
    ] as const;
    }


export const getProjectsControllerAcceptMilestoneV1QueryOptions = <TData = Awaited<ReturnType<typeof projectsControllerAcceptMilestoneV1>>, TError = unknown>(id: MaybeRef<string>,
    eventId: MaybeRef<string>,
    acceptMilestoneDto: MaybeRef<AcceptMilestoneDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerAcceptMilestoneV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getProjectsControllerAcceptMilestoneV1QueryKey(id,eventId,acceptMilestoneDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsControllerAcceptMilestoneV1>>> = ({ signal }) => projectsControllerAcceptMilestoneV1(unref(id),unref(eventId),unref(acceptMilestoneDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined && unref(eventId) !== null && unref(eventId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectsControllerAcceptMilestoneV1>>, TError, TData>
}

export type ProjectsControllerAcceptMilestoneV1QueryResult = NonNullable<Awaited<ReturnType<typeof projectsControllerAcceptMilestoneV1>>>
export type ProjectsControllerAcceptMilestoneV1QueryError = unknown


/**
 * @summary Принять / снять приёмку контрольной точки
 */

export function useProjectsControllerAcceptMilestoneV1<TData = Awaited<ReturnType<typeof projectsControllerAcceptMilestoneV1>>, TError = unknown>(
 id: MaybeRef<string>,
    eventId: MaybeRef<string>,
    acceptMilestoneDto: MaybeRef<AcceptMilestoneDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerAcceptMilestoneV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsControllerAcceptMilestoneV1QueryOptions(id,eventId,acceptMilestoneDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export interface projectsControllerListMaterialsV1Response200 {
  data: ProjectMaterialDto[]
  status: 200
}

export type projectsControllerListMaterialsV1ResponseSuccess = (projectsControllerListMaterialsV1Response200) & {
  headers: Headers;
};
;

export type projectsControllerListMaterialsV1Response = (projectsControllerListMaterialsV1ResponseSuccess)

export const getProjectsControllerListMaterialsV1Url = (id: string,
    params?: ProjectsControllerListMaterialsV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/projects/${id}/materials?${stringifiedParams}` : `/api/v1/projects/${id}/materials`
}

/**
 * @summary Материалы и документы проекта
 */
export const projectsControllerListMaterialsV1 = async (id: string,
    params?: ProjectsControllerListMaterialsV1Params, options?: RequestInit): Promise<projectsControllerListMaterialsV1Response> => {

  return apiRequest<projectsControllerListMaterialsV1Response>(getProjectsControllerListMaterialsV1Url(id,params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getProjectsControllerListMaterialsV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsControllerListMaterialsV1>>, TError,{id: string;params?: ProjectsControllerListMaterialsV1Params}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof projectsControllerListMaterialsV1>>, TError,{id: string;params?: ProjectsControllerListMaterialsV1Params}, TContext> => {

const mutationKey = ['projectsControllerListMaterialsV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectsControllerListMaterialsV1>>, {id: string;params?: ProjectsControllerListMaterialsV1Params}> = (props) => {
          const {id,params} = props ?? {};

          return  projectsControllerListMaterialsV1(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProjectsControllerListMaterialsV1MutationResult = NonNullable<Awaited<ReturnType<typeof projectsControllerListMaterialsV1>>>

    export type ProjectsControllerListMaterialsV1MutationError = unknown

    /**
 * @summary Материалы и документы проекта
 */
export const useProjectsControllerListMaterialsV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsControllerListMaterialsV1>>, TError,{id: string;params?: ProjectsControllerListMaterialsV1Params}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof projectsControllerListMaterialsV1>>,
        TError,
        {id: string;params?: ProjectsControllerListMaterialsV1Params},
        TContext
      > => {
      return useMutation(getProjectsControllerListMaterialsV1MutationOptions(options), queryClient);
    }
    export interface projectsControllerCreateMaterialV1Response200 {
  data: ProjectMaterialDto
  status: 200
}

export type projectsControllerCreateMaterialV1ResponseSuccess = (projectsControllerCreateMaterialV1Response200) & {
  headers: Headers;
};
;

export type projectsControllerCreateMaterialV1Response = (projectsControllerCreateMaterialV1ResponseSuccess)

export const getProjectsControllerCreateMaterialV1Url = (id: string,) => {




  return `/api/v1/projects/${id}/materials`
}

/**
 * @summary Добавить материал: ссылка или файл
 */
export const projectsControllerCreateMaterialV1 = async (id: string,
    projectsControllerCreateMaterialV1Body: ProjectsControllerCreateMaterialV1Body, options?: RequestInit): Promise<projectsControllerCreateMaterialV1Response> => {
    const formData = new FormData();
if(projectsControllerCreateMaterialV1Body.file !== undefined) {
 formData.append(`file`, projectsControllerCreateMaterialV1Body.file);
 }
formData.append(`title`, projectsControllerCreateMaterialV1Body.title);
if(projectsControllerCreateMaterialV1Body.description !== undefined) {
 formData.append(`description`, projectsControllerCreateMaterialV1Body.description);
 }
if(projectsControllerCreateMaterialV1Body.url !== undefined) {
 formData.append(`url`, projectsControllerCreateMaterialV1Body.url);
 }
if(projectsControllerCreateMaterialV1Body.areaId !== undefined) {
 formData.append(`areaId`, projectsControllerCreateMaterialV1Body.areaId);
 }
if(projectsControllerCreateMaterialV1Body.eventId !== undefined) {
 formData.append(`eventId`, projectsControllerCreateMaterialV1Body.eventId);
 }
if(projectsControllerCreateMaterialV1Body.folderId !== undefined) {
 formData.append(`folderId`, projectsControllerCreateMaterialV1Body.folderId);
 }

  return apiRequest<projectsControllerCreateMaterialV1Response>(getProjectsControllerCreateMaterialV1Url(id),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getProjectsControllerCreateMaterialV1QueryKey = (id: MaybeRef<string>,
    projectsControllerCreateMaterialV1Body?: MaybeRef<ProjectsControllerCreateMaterialV1Body>,) => {
    return [
    'POST', 'api','v1','projects',id,'materials', projectsControllerCreateMaterialV1Body
    ] as const;
    }


export const getProjectsControllerCreateMaterialV1QueryOptions = <TData = Awaited<ReturnType<typeof projectsControllerCreateMaterialV1>>, TError = unknown>(id: MaybeRef<string>,
    projectsControllerCreateMaterialV1Body: MaybeRef<ProjectsControllerCreateMaterialV1Body>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerCreateMaterialV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getProjectsControllerCreateMaterialV1QueryKey(id,projectsControllerCreateMaterialV1Body);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsControllerCreateMaterialV1>>> = ({ signal }) => projectsControllerCreateMaterialV1(unref(id),unref(projectsControllerCreateMaterialV1Body), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectsControllerCreateMaterialV1>>, TError, TData>
}

export type ProjectsControllerCreateMaterialV1QueryResult = NonNullable<Awaited<ReturnType<typeof projectsControllerCreateMaterialV1>>>
export type ProjectsControllerCreateMaterialV1QueryError = unknown


/**
 * @summary Добавить материал: ссылка или файл
 */

export function useProjectsControllerCreateMaterialV1<TData = Awaited<ReturnType<typeof projectsControllerCreateMaterialV1>>, TError = unknown>(
 id: MaybeRef<string>,
    projectsControllerCreateMaterialV1Body: MaybeRef<ProjectsControllerCreateMaterialV1Body>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerCreateMaterialV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsControllerCreateMaterialV1QueryOptions(id,projectsControllerCreateMaterialV1Body,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export interface projectsControllerGetMaterialDownloadUrlV1Response200 {
  data: ProjectMaterialDownloadUrlDto
  status: 200
}

export type projectsControllerGetMaterialDownloadUrlV1ResponseSuccess = (projectsControllerGetMaterialDownloadUrlV1Response200) & {
  headers: Headers;
};
;

export type projectsControllerGetMaterialDownloadUrlV1Response = (projectsControllerGetMaterialDownloadUrlV1ResponseSuccess)

export const getProjectsControllerGetMaterialDownloadUrlV1Url = (id: string,
    materialId: string,) => {




  return `/api/v1/projects/${id}/materials/${materialId}/download-url`
}

/**
 * @summary Presigned-ссылка на файл материала
 */
export const projectsControllerGetMaterialDownloadUrlV1 = async (id: string,
    materialId: string, options?: RequestInit): Promise<projectsControllerGetMaterialDownloadUrlV1Response> => {

  return apiRequest<projectsControllerGetMaterialDownloadUrlV1Response>(getProjectsControllerGetMaterialDownloadUrlV1Url(id,materialId),
  {
    ...options,
    method: 'GET'


  }
);}




export const getProjectsControllerGetMaterialDownloadUrlV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsControllerGetMaterialDownloadUrlV1>>, TError,{id: string;materialId: string}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof projectsControllerGetMaterialDownloadUrlV1>>, TError,{id: string;materialId: string}, TContext> => {

const mutationKey = ['projectsControllerGetMaterialDownloadUrlV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectsControllerGetMaterialDownloadUrlV1>>, {id: string;materialId: string}> = (props) => {
          const {id,materialId} = props ?? {};

          return  projectsControllerGetMaterialDownloadUrlV1(id,materialId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProjectsControllerGetMaterialDownloadUrlV1MutationResult = NonNullable<Awaited<ReturnType<typeof projectsControllerGetMaterialDownloadUrlV1>>>

    export type ProjectsControllerGetMaterialDownloadUrlV1MutationError = unknown

    /**
 * @summary Presigned-ссылка на файл материала
 */
export const useProjectsControllerGetMaterialDownloadUrlV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsControllerGetMaterialDownloadUrlV1>>, TError,{id: string;materialId: string}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof projectsControllerGetMaterialDownloadUrlV1>>,
        TError,
        {id: string;materialId: string},
        TContext
      > => {
      return useMutation(getProjectsControllerGetMaterialDownloadUrlV1MutationOptions(options), queryClient);
    }
    export interface projectsControllerRemoveMaterialV1Response204 {
  data: void
  status: 204
}

export type projectsControllerRemoveMaterialV1ResponseSuccess = (projectsControllerRemoveMaterialV1Response204) & {
  headers: Headers;
};
;

export type projectsControllerRemoveMaterialV1Response = (projectsControllerRemoveMaterialV1ResponseSuccess)

export const getProjectsControllerRemoveMaterialV1Url = (id: string,
    materialId: string,) => {




  return `/api/v1/projects/${id}/materials/${materialId}`
}

/**
 * @summary Удалить материал
 */
export const projectsControllerRemoveMaterialV1 = async (id: string,
    materialId: string, options?: RequestInit): Promise<projectsControllerRemoveMaterialV1Response> => {

  return apiRequest<projectsControllerRemoveMaterialV1Response>(getProjectsControllerRemoveMaterialV1Url(id,materialId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getProjectsControllerRemoveMaterialV1QueryKey = (id: MaybeRef<string>,
    materialId: MaybeRef<string>,) => {
    return [
    'DELETE', 'api','v1','projects',id,'materials',materialId
    ] as const;
    }


export const getProjectsControllerRemoveMaterialV1QueryOptions = <TData = Awaited<ReturnType<typeof projectsControllerRemoveMaterialV1>>, TError = unknown>(id: MaybeRef<string>,
    materialId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerRemoveMaterialV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getProjectsControllerRemoveMaterialV1QueryKey(id,materialId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsControllerRemoveMaterialV1>>> = ({ signal }) => projectsControllerRemoveMaterialV1(unref(id),unref(materialId), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined && unref(materialId) !== null && unref(materialId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectsControllerRemoveMaterialV1>>, TError, TData>
}

export type ProjectsControllerRemoveMaterialV1QueryResult = NonNullable<Awaited<ReturnType<typeof projectsControllerRemoveMaterialV1>>>
export type ProjectsControllerRemoveMaterialV1QueryError = unknown


/**
 * @summary Удалить материал
 */

export function useProjectsControllerRemoveMaterialV1<TData = Awaited<ReturnType<typeof projectsControllerRemoveMaterialV1>>, TError = unknown>(
 id: MaybeRef<string>,
    materialId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerRemoveMaterialV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsControllerRemoveMaterialV1QueryOptions(id,materialId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






